import {
  Badge,
  Breadcrumb,
  Button,
  Input,
  message,
  Modal,
  Tooltip,
} from "antd";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { NavLink } from "react-router-dom";

import { em } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

import {
  faBell,
  faCalculator,
  faRotate,
  faStickyNote,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { authLogout } from "../../store/actions/auth-actions";
import {
  fetchSystemNotifications,
  setUsersSystemNotifications,
  synchronizeRecords,
} from "../../store/actions/settings-actions";

// SVG Images
import HamburgerCollapse from "../svgs/hamburgerCollapse";
import Hamburger from "../svgs/hamburgerSvg";

import { Popover } from "antd";
import { IoClose, IoSearch } from "react-icons/io5";
import { PiGearSixDuotone, PiSignOutDuotone } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import StyledImage from "../image/StyledImage";

import useAppStore from "../../store/zustand-store/app.store";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name, subName, onPress, mainProps }) {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.user);
  const rawPermission = useSelector(
    (state) => state?.auth?.user?.role?.permission?.permission
  );
  const permissions = rawPermission
    ? JSON.parse(rawPermission).strPermission
    : [];

  const { isSidebarLTPortalCollapse, setSidebarLTPortalCollapse } =
    useAppStore();
  const { systemNotification } = useSelector((state) => state.systemSettings);

  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const history = useHistory();

  const handleClick = () => {
    dispatch(authLogout());
  };

  const handleSync = () => {
    Modal.confirm({
      title: `Synchronize Leads and Cases`,
      content: `This action will let you get all latest leads and cases updates. 
      Are you sure you want to initiate record synchronization?`,
      onOk: () => {
        dispatch(synchronizeRecords());
      },
    });
  };

  const onSearch = (value, _e, info) => {
    if (!value) message.error("Search text should not be empty");
    else if (value?.length < 3)
      message.error("Search length should be atleast 3 character!");
    else mainProps.props.history.push(`/search/search-result/${value}`);
  };

  useEffect(() => {
    let pageNotifications = systemNotification?.notifications;
    // console.log(pageNotifications)
    // manage nofication count and what notification to display
    // console.log(systemNotification?.notifications)
    // setNotifCount(systemNotification?.notifications?.length || 0);
    if (pageNotifications === undefined) {
      dispatch(
        fetchSystemNotifications({
          sort: "createdAt,desc",
          clientEmail: currentUser.email,
        })
      );
      setNotifCount(pageNotifications?.length || 0);
    }
    if (pageNotifications?.length > 0) {
      if (!currentUser.Receive_Comments_Notification) {
        pageNotifications = pageNotifications.filter((notif) => {
          return !["lead-comment", "case-comment"].includes(notif.scope);
        });
      }
      if (!currentUser.Receive_Files_Notification) {
        pageNotifications = pageNotifications.filter((notif) => {
          return !["lead-file", "case-file"].includes(notif.scope);
        });
      }
      if (!currentUser.Receive_Leads_Notification) {
        pageNotifications = pageNotifications.filter((notif) => {
          return !["lead"].includes(notif.scope);
        });
      }
      if (!currentUser.Receive_Cases_Notification) {
        pageNotifications = pageNotifications.filter((notif) => {
          return !["case"].includes(notif.scope);
        });
      }
      var tCount = pageNotifications.filter((test) => {
        return !test.isRead;
      });
      setNotifCount(tCount.length || 0);
      dispatch(setUsersSystemNotifications(pageNotifications));
    }

    // eslint-disable-next-line
  }, [systemNotification]); // Only re-run the effect if 'systemNotification' changes\

  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => setOpen(newOpen);
  const isMobile = useMediaQuery(`(max-width: ${em(992)})`);

  const SidebarToggleClass = useCallback((collapse) => {
    document.body.classList.toggle("sidebar-collapse", collapse);
  }, []);

  useEffect(() => {
    SidebarToggleClass(isSidebarLTPortalCollapse);
  }, [isSidebarLTPortalCollapse]);

  const handleToggleSidebar = useCallback(() => {
    if (isMobile) {
      document.body.classList.toggle("mobile-expand", true);
    } else {
      SidebarToggleClass(!isSidebarLTPortalCollapse);

      setSidebarLTPortalCollapse(!isSidebarLTPortalCollapse);
    }
  }, [isSidebarLTPortalCollapse, isMobile]);

  useEffect(() => {
    document.body.classList.toggle("is-mobile", isMobile);
  }, [isMobile]);

  const handleLogoutClick = () => {
    dispatch(authLogout());
  };

  const [showSearchModal, setShowSearchModal] = useState(false);
  const handleOnSearchKeyDown = useCallback(
    (event) => {
      if (event.keyCode === 13) {
        console.log("Enter key pressed", event);

        onSearch?.(event.target.value);
        setShowSearchModal(false);
      }
    },
    [onSearch]
  );

  // console.log({ isSidebarLTPortalCollapse });

  return (
    <>
      <div className="min-h-16 flex flex-row items-center px-4 border-b bg-white justify-between shadow-sm border-black">
        <div className="flex flex-row items-center gap-2">
          <div
            className="header-toggle-btn hover:cursor-pointer hover:bg-slate-100 px-1 py-1 rounded-md fill-black"
            onClick={() => handleToggleSidebar()}
          >
            {isSidebarLTPortalCollapse && <Hamburger size={24} />}
            {!isSidebarLTPortalCollapse && <HamburgerCollapse size={24} />}
          </div>
          <div
            onClick={() => setShowSearchModal(true)}
            className="hover:cursor-pointer text-slate-400 hover:text-slate-800 hover:bg-slate-100 px-1 py-1 rounded-md"
          >
            <IoSearch size={22} />
          </div>
        </div>

        <div className="flex flex-row gap-2 pr-6 items-center">
          <div className="flex flex-row gap-0 items-center">
            {_.find(permissions, { id: "proposal" })?.state === 1 && (
              <div
                style={{ paddingRight: 10 }}
                className="bg-violet-100 border border-violet-300 hover:bg-violet-200 rounded-lg font-bold !py-[0.1rem] text-xs px-2 select-none transition ease-in flex flex-row items-center gap-[0.3rem] pulse-anim"
              >
                <Tooltip placement="bottom" title="View LT Proposal System">
                  <Button
                    type="link"
                    className="!text-violet-700 hover:!text-violet-900 px-2"
                    onClick={() =>
                      mainProps.props.history.push(`/app/dashboard`)
                    }
                  >
                    <FontAwesomeIcon icon={faStickyNote} />
                    <span>LT Proposal System</span>
                  </Button>
                </Tooltip>
              </div>
            )}

            <div>
              <Tooltip placement="bottom" title="View calculators">
                <Button
                  type="link"
                  className="!text-black"
                  onClick={() => window.open("/calculator", "_blank")}
                >
                  <FontAwesomeIcon icon={faCalculator} />
                  <span>Calculator</span>
                </Button>
              </Tooltip>
            </div>

            <Tooltip
              placement="bottom"
              title="Pull and update Leads and Deals records"
            >
              <Button
                type="link"
                onClick={handleSync}
                className="!text-black px-0"
              >
                <FontAwesomeIcon icon={faRotate} />
                <span>Sync Records</span>
              </Button>
            </Tooltip>

            <div className="px-4">
              <Tooltip placement="bottom" title="Notifications">
                <Badge size="small" count={notifCount}>
                  <FontAwesomeIcon
                    icon={faBell}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      mainProps.props.history.push(`/notifications`);
                    }}
                  />
                </Badge>
              </Tooltip>
            </div>
          </div>
          <div>
            <Popover
              placement="bottomRight"
              content={
                <div className="w-[250px]">
                  <div className="flex flex-row gap-4 py-2 pb-4 items-center max-w-full">
                    <div className="flex-shrink">
                      <StyledImage
                        src={currentUser?.picture}
                        renderType="avatar"
                        className="shadow-lg"
                        style={{
                          width: 45,
                          height: 45,
                          minWidth: 30,
                          borderRadius: 100,
                          border: "1px solid #dedede",
                        }}
                      />
                    </div>
                    <div className="flex-1 flex flex-col justify-center">
                      <div className="font-semibold word-break">{`${currentUser?.firstName} ${currentUser?.lastName}`}</div>
                      <div className="text-slate-500 font-light tracking-wide word-break">{`${currentUser?.email}`}</div>
                    </div>
                  </div>
                  <div className="border-t">
                    <ul className="header-nav">
                      <li>
                        <a
                          className="flex flex-row"
                          onClick={() => history.push("/profile")}
                        >
                          <PiGearSixDuotone
                            size={22}
                            className="inline-flex mr-1"
                          />
                          <span className="inline-flex">Account Setting</span>
                        </a>
                      </li>
                      <li>
                        <a
                          className="flex flex-row"
                          onClick={() => handleLogoutClick()}
                        >
                          <PiSignOutDuotone
                            size={22}
                            className="inline-flex mr-1"
                          />
                          <span className="inline-flex">Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              }
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <StyledImage
                src={currentUser?.picture}
                renderType="avatar"
                className="shadow-lg hover:cursor-pointer"
                style={{
                  width: 45,
                  height: 45,
                  minWidth: 30,
                  borderRadius: 100,
                  border: "1px solid #dedede",
                }}
              />
            </Popover>
          </div>
        </div>
      </div>
      <div>
        <div className="px-6 py-4">
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Home</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {name.replace("/", "")}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {subName.replace("/", "")}
            </span>
          </div>
        </div>
      </div>

      {/* Modal Search */}
      {showSearchModal && (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-white/90 z-[9999] flex flex-row items-center justify-center">
          <div
            onClick={() => setShowSearchModal(false)}
            className="absolute top-4 right-4 text-slate-600 hover:text-slate-800 hover:cursor-pointer"
          >
            <IoClose size={32} />
          </div>
          <div direction="vertical" className="bg-white rounded-lg">
            <Input
              addonBefore={<IoSearch />}
              size="large"
              placeholder="Search Leads, Cases or Users"
              className="w-[360px] !border-slate-500"
              onKeyDown={handleOnSearchKeyDown}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
